
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import {dictApi, dictInstrumentApi} from "@/api/organization";
    import TempSave from "@/components/TempSave.vue";
    import EmptyContent from "@/components/EmptyContent.vue";
    import SelectRules from "@/components/SelectRules.vue";
    import {rulesApi} from "@/api/rules";

    @Component({name: 'Sys_Instrument_Catalogue', components: {EmptyContent, TempSave, SetTableColumns, SelectRules}})
    export default class Home extends Vue {
        title = '强检目录字典';
        treeList = [] as any; //这个是处理过后的数据
        orgTreeList = [] as any; //源数据
        defaultProps = {
            children: 'children',
            label: 'catalogueName'
        }
        dialog = {
            mode: "", // ADD or EDIT
            visible: false,
            node: null as any,
        }
        rules = {
            catalogueName: [{required: true, message: '请输入强检目录名称', trigger: 'blur'}],
            orderIndex: [{required: true, message: '请输入排序号', trigger: 'blur'}],
            ruleNumber: [{required: true, message: '请输入规程规范编号', trigger: 'change'}],
            catalogueArr: [{required: true, message: '请选择项别种别', trigger: 'change'}]
        }
        moveDialog = {
            visible: false,
            formInstrCatId: 0,
            toInstrCatId: 0,
            treeList: [],
        }
        allSelected = [];
        loading = false;
        ruleList = [];
        catalogueList = [];
        expandedKeys = [];

        created() {
            this.getListInstrument();
        }
        changeMeasuringRule() {
            const rule: any = this.ruleList.find((r: any) => this.getRuleFullNumber(r) == this.dialog.node.ruleNumber || r.number == this.dialog.node.ruleNumber);
            if (rule) {
                this.dialog.node.ruleNumber = this.getRuleFullNumber(rule);
                this.dialog.node.ruleName = rule.name;
            }
        }
        getRuleFullNumber(rule: any) {
            return rule ? (rule.fullNumber || rule.full_number || rule.number || "") : "";
        }
        getRuleOptionLabel(rule: any) {
            const number = this.getRuleFullNumber(rule);
            return rule && rule.name ? (number + " " + rule.name) : number;
        }
        findExpandedNode() { // 寻找所有展开的节点id
            const list = [] as any;
            const el = this.$refs['treeList'] as any;
            this.treeList.forEach((element: any) => {
                if (el.getNode(element).expanded === true) {
                    list.push(element.id)
                }
            })
            return list
        }
        getListInstrument() {
            this.loading = true;
            dictApi.listInstrumentCatalogueTree().then(r => {
                if (r.data.result === 0) {
                    const dataList = r.data.data;
                    this.orgTreeList = this.cloneData(dataList);
                    this.porjectTree(dataList, 1);
                    this.treeList = this.cloneData(dataList);
                    this.loading = false;
                }
            });

            dictApi.listDictCatalogueTree().then(r => {
               if(r.data.result === 0){
                   const dataList = r.data.data;
                   this.porjectTree(dataList, 1);
                   this.catalogueList = dataList;
               }
            });
        }

        porjectTree(projectList: any, level: number) {
            projectList.forEach((project: any) => {
                project.level = level;
                if (project.children.length == 0) {
                    project.children = null;
                } else {
                    this.porjectTree(project.children, (level + 1));
                }
            })
        }

        porjectTreeV2(projectList: any, level: number, disableLevel: number) {
            projectList.forEach((project: any) => {
                project.level = level;
                if (level != disableLevel) {
                    project.disabled = true;
                }
                if (project.children.length == 0) {
                    project.children = null;
                } else {
                    this.porjectTreeV2(project.children, (level + 1), disableLevel);
                }
            })
        }

        operation(mode: any) {
            const el = this.$refs['treeList'] as any;
            const dataArr = el.getCheckedNodes();
            if (dataArr.length == 0 && (['move', 'edit', 'del']).indexOf(mode) > -1) {
                this.$message.warning("请先勾选");
                return;
            }
            if (dataArr.length > 1) {
                this.$message.warning("只能勾选一条");
                return;
            }
            const node = dataArr.length == 0 ? null : dataArr[0];
            if (mode == "move") {
                this.moveInstrumentModal(node);
            } else if (mode == 'edit') {
                this.updateInstrumentModal(node);
            } else if (mode == 'add') {
                this.addInstrumentModal(node);
            } else if (mode == 'del') {
                this.deleteInstrument(node);
            }
        }

        moveInstrumentModal(node: any) {
            this.moveDialog.formInstrCatId = node.id;
            const treeList = this.cloneData(this.orgTreeList);
            this.porjectTreeV2(treeList, 1, node.level - 1)
            this.moveDialog.treeList = treeList;
            this.moveDialog.visible = true;
        }

        submitMoveDialog() {
            const el = this.$refs['toTreeList'] as any;
            const dataArr = el.getCheckedNodes();
            if (dataArr.length == 0) {
                this.$message.warning("请先勾选");
                return;
            }
            if (dataArr.length > 1) {
                this.$message.warning("只能勾选一条");
                return;
            }
            const node = dataArr[0];
            this.moveDialog.toInstrCatId = node.id;
            dictInstrumentApi.moveInstrumentCatalogue({
                formInstrCatId: this.moveDialog.formInstrCatId,
                toInstrCatId: this.moveDialog.toInstrCatId
            }).then((r: any) => {
                if (r.data.result == 0) {
                    this.closeDialog();
                    this.getListInstrument();
                }
            });
        }

        cloneData(data: any) {
            return JSON.parse(JSON.stringify(data));
        }

        addInstrumentModal(parentNode: any) {
            this.dialog.mode = "ADD";
            if (parentNode == null) {
                const node = this.getInitNodeData();
                node.parentId = 0;
                node.level = 1;
                this.dialog.node = node;
                this.dialog.visible = true;
            } else {
                if (parentNode.children == null && parentNode.level != 1) {
                    this.$message.warning("最后一级不支持新增！")
                    return;
                }
                const node = this.getInitNodeData();
                node.parentId = parentNode.id;
                node.level = 2;
                this.dialog.node = node;
                this.dialog.visible = true;
            }

        }

        updateInstrumentModal(currentNode: any) {
            this.dialog.mode = "EDIT";
            const node = this.getInitNodeData();
            Object.assign(node, currentNode)
            node.catalogueArr = [currentNode.categoryCode, currentNode.classCode];
            this.dialog.node = node;
            this.dialog.visible = true;
        }

        deleteInstrument(node: any) {
            if (node.children != null && node.children.length > 0) {
                this.$message.warning("以上强检目录字典已被使用不能删除！")
                return;
            }
            this.$confirm('确定要删除 【' + node.catalogueName + '】强检目录字典吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                dictInstrumentApi.delInstrumentCatalogue({instrCatId: node.id}).then((r: any) => {
                    if (r.data.result == 0) {
                        this.getListInstrument();
                    }
                });
            });
        }

        getInitNodeData() {
            return {
                id: 0,
                parentId: 0,
                catalogueName: "",
                level: 0,
                ruleNumber: "",
                ruleName: "",
                orderIndex: 0,
                catalogueArr: [] as Array<string>,
            }
        }

        closeDialog() {
            this.dialog.mode = '';
            this.dialog.visible = false;
            this.dialog.node = null;
            this.moveDialog.visible = false;
            this.moveDialog.formInstrCatId = 0;
            this.moveDialog.toInstrCatId = 0;
            this.moveDialog.treeList = [];
        }

        submitBefore() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    this.submitDialog();
                } else {
                    this.$message.warning("未填写完整信息");
                }
            });
        }

        submitDialog() {
            let api = null;
            const node = this.dialog.node;
            const catalogueArr = node.catalogueArr;
            const params = {
                orderIndex: node.orderIndex,
                ruleNumber: node.ruleNumber,
                ruleName: node.ruleName,
                catalogueName: node.catalogueName,
            } as any;
            if(catalogueArr && catalogueArr.length > 1){
                params.categoryCode = catalogueArr[0];
                const category = this.catalogueList.find((e:any) => e.code == params.categoryCode) as any;
                params.categoryName = category.name;
                params.classCode= catalogueArr[1];
                const clazz = category.children.find((e:any) => e.code == params.classCode) as any;
                params.className = clazz.name;
            }
            if (this.dialog.mode == "ADD") {
                params.parentId = node.parentId;
                api = dictInstrumentApi.addInstrumentCatalogue(params);
            } else {
                params.instrCatId = node.id
                api = dictInstrumentApi.updateInstrumentCatalogue(params);
            }
            this.expandedKeys = this.findExpandedNode();
            api.then((r: any) => {
                if (r.data.result == 0) {
                    this.closeDialog();
                    this.getListInstrument();
                }
            });
        }
        filterRules(keyword: string) {
            if (keyword != "") {
                let keyword1 = ""; // 正则匹配出 [A-Z]+
                let key1s = /[A-Za-z]+/i.exec(keyword);
                if (key1s != null && key1s.length > 0) {
                    keyword1 = key1s[0].toUpperCase();
                }
                let keyword2 = ""; //正则匹配出 \d+
                let key2s = /[\d-]+/i.exec(keyword);
                if (key2s != null && key2s.length > 0) {
                    keyword2 = key2s[0];
                }
                let keyword3 = ""; //正则匹配出 常见汉字
                let key3s = /[\u4E00-\u9FFF]+/i.exec(keyword);
                if (key3s != null && key3s.length > 0) {
                    keyword3 = key3s[0];
                }
                rulesApi.listRulesCopy({keyword1: keyword1, keyword2: keyword2, keyword3: keyword3}).then((r) => {
                    if (r.data.result === 0) {
                        this.ruleList = r.data.data;
                    }
                });
            } else {
                this.ruleList = [];
            }
        }

    }
